export default function PaperList() {
  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <h1 className="aip-main__header-title">論文共有</h1>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="papers-container">
          <section className="papers-section">
            <h2>リンク集</h2>
            <div className="papers-links">
              <div className="papers-category">
                <h3>●AI論文検索</h3>
                <ul>
                  <li><a href="https://elicit.org" target="_blank" rel="noopener noreferrer">Elicit</a></li>
                  <li><a href="https://consensus.app" target="_blank" rel="noopener noreferrer">Consensus</a></li>
                </ul>
              </div>

              <div className="papers-category">
                <h3>●おすすめの検索エンジン</h3>
                <ul>
                  <li><a href="https://pubmed.ncbi.nlm.nih.gov" target="_blank" rel="noopener noreferrer">PubMed</a></li>
                </ul>
              </div>

              <div className="papers-category">
                <h3>●信頼できるフルオープンアクセス誌の一例</h3>
                <ul>
                  <li><a href="https://www.nature.com/ncomms/" target="_blank" rel="noopener noreferrer">Nature Communications</a></li>
                  <li><a href="https://plos.org" target="_blank" rel="noopener noreferrer">PLOS</a></li>
                </ul>
              </div>

              <div className="papers-category">
                <h3>●信頼できるジャーナル検索</h3>
                <ul>
                  <li><a href="https://doaj.org" target="_blank" rel="noopener noreferrer">Directory of Open Access Journals – DOAJ</a></li>
                  <li><a href="https://thinkchecksubmit.org" target="_blank" rel="noopener noreferrer">Think, Check, Submit.</a></li>
                </ul>
              </div>
            </div>
          </section>

          <section className="papers-section">
            <h2>最近共有された論文</h2>
            <div className="papers-list">
              <article className="paper-card">
                <h3 className="paper-card__title">
                  腸粘膜のミトコンドリア酸化的リン酸化は肝硬変の進行に伴い悪化し、糞便微生物叢移植により改善される
                </h3>
                <p className="paper-card__journal">JCI Insight (American Society for Clinical Investigation)</p>
                <p className="paper-card__date">公開日: 2025年1月7日</p>
                <a href="https://insight.jci.org/articles/view/186649" target="_blank" rel="noopener noreferrer" className="paper-card__link">
                  論文を見る
                  <span className="material-symbols-outlined">open_in_new</span>
                </a>
              </article>

              <article className="paper-card">
                <h3 className="paper-card__title">
                  ポジティブな小児期体験はASDおよびADHD特性を持つ日本人若年層の自殺リスクを軽減する
                </h3>
                <p className="paper-card__date">公開日: 2025年1月10日</p>
              </article>

              <article className="paper-card">
                <h3 className="paper-card__title">
                  歯周炎患者は持続的な腸内細菌叢のディスバイオシスと特徴的な血清メタボロームを示す
                </h3>
                <p className="paper-card__date">公開日: 2025年1月15日</p>
              </article>
            </div>
          </section>
        </div>
      </div>

      <style>{`
        .papers-container {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-lg);
        }

        .papers-section {
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .papers-section h2 {
          font-size: 1.125rem;
          font-weight: 600;
          margin-bottom: var(--spacing-md);
        }

        .papers-links {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-md);
        }

        .papers-category h3 {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: var(--spacing-xs);
        }

        .papers-category ul {
          list-style: none;
          padding-left: var(--spacing-md);
        }

        .papers-category li {
          margin-bottom: var(--spacing-xs);
        }

        .papers-category a {
          color: var(--color-blue600);
        }

        .papers-list {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-md);
        }

        .paper-card {
          padding: var(--spacing-md);
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius-md);
        }

        .paper-card__title {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: var(--spacing-xs);
        }

        .paper-card__journal {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .paper-card__date {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .paper-card__link {
          display: inline-flex;
          align-items: center;
          gap: var(--spacing-xs);
          margin-top: var(--spacing-sm);
          font-size: 0.875rem;
          color: var(--color-blue600);
        }

        .paper-card__link .material-symbols-outlined {
          font-size: 16px;
        }
      `}</style>
    </>
  )
}




